webpackJsonp([122],{

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("7965afe3", content, true, {});

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".Iframe1 .placeholder{width:100%;height:100%;color:#999;background-color:#f9f9f9}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Iframe1/src/components/contents/Iframe1/Iframe1.s.scss"],"names":[],"mappings":"AAEA,sBAEI,WAAW,AACX,YAAY,AACZ,WAAW,AACX,wBAAyB,CAC1B","file":"Iframe1.scss","sourcesContent":["@import '~scss/variables';\n\n.Iframe1 {\n  .placeholder {\n    width: 100%;\n    height: 100%;\n    color: #999;\n    background-color: #f9f9f9;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/122.a7b5320c0fd7099f46d4.js